import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

export async function submitContact(payload) {
  const { data } = await api.post("/contact", payload);
  return data;
}

export async function requestEstimate(payload) {
  const { data } = await api.post("/estimate", payload);
  return data;
}

/**
 * Streams a chatbot response via SSE.
 * onSession(sessionId), onDelta(text), onDone(), onError(msg)
 */
export async function streamChat({ sessionId, message, onSession, onDelta, onDone, onError }) {
  try {
    const resp = await fetch(`${API_BASE}/chat/stream`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ session_id: sessionId, message }),
    });
    if (!resp.ok || !resp.body) {
      onError && onError(`Request failed: ${resp.status}`);
      return;
    }
    const reader = resp.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const parts = buffer.split("\n\n");
      buffer = parts.pop() || "";
      for (const chunk of parts) {
        const line = chunk.split("\n").find(l => l.startsWith("data: "));
        if (!line) continue;
        try {
          const evt = JSON.parse(line.slice(6));
          if (evt.type === "session") onSession && onSession(evt.session_id);
          else if (evt.type === "delta") onDelta && onDelta(evt.content);
          else if (evt.type === "done") onDone && onDone();
          else if (evt.type === "error") onError && onError(evt.message);
        } catch (_) {}
      }
    }
    onDone && onDone();
  } catch (e) {
    onError && onError(e.message || String(e));
  }
}
